import { render, staticRenderFns } from "./topicCreate.vue?vue&type=template&id=694b7a75"
import script from "./topicCreate.vue?vue&type=script&lang=js"
export * from "./topicCreate.vue?vue&type=script&lang=js"
import style0 from "./topicCreate.vue?vue&type=style&index=0&id=694b7a75&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('694b7a75')) {
      api.createRecord('694b7a75', component.options)
    } else {
      api.reload('694b7a75', component.options)
    }
    module.hot.accept("./topicCreate.vue?vue&type=template&id=694b7a75", function () {
      api.rerender('694b7a75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/promotion/topicCreate.vue"
export default component.exports